import {NgIf} from '@angular/common';
import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {ComponentsModule} from '../../../components/components.module';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {FinanceWalletModel} from '../../../models/finance.model';
import {ValuePropertyModel} from '../../../models/property.model';
import {TaskModel} from '../../../models/task.model';
import {BoardGroupModel, BoardTableModel} from '../../../models/tasktable.model';
import {MemberModel} from '../../../models/user.model';
import {CrmService} from '../../../services/api/crm.service';
import {AlertService} from '../../../services/notify/alert.service';
import {TaskServiceService} from '../../../services/task-service.service';
import {DocumentsServiceService} from '../../documents/documents-service.service';

@Component({
    selector: 'app-template',
    standalone: true,
    imports: [
        ComponentsModule,
        TranslatePipe,
        NgIf,
    ],
    templateUrl: './template.component.html',
    styleUrl: './template.component.scss'
})
export class TemplateComponent {
    // Инлайн инпут
    editByPen = false;
    bold = false;

    //Ckeditor
    isShowButtons = false;

    //button more
    hiddenMore = false;
    boldMore = false;

    //calendar
    inlineCalendar = false;
    hiddenCalendar = false;
    showTime = false;

    //Documents table
    isMini = 'default';
    showBackButton = true;

    //Tasks table
    minimizedTaskTable = false;

    //Tasks detail
    taskAliasValue: string = '';
    detailPaymentView: boolean = false;

    //Payment detail
    paymentGuidValue: string = '';

    //column tasks
    boardAliasValue: string = '';

    //task dashboards
    boards: BoardTableModel[];
    boardGroups: BoardGroupModel[];

    //Documents
    documentKey: string;

    //taskComments
    taskData: TaskModel = null;

    //task logs
    taskAliasLogsValue: string = '';

    //Визоры
    visorsFileKeyValue: string = '';

    jsonDataToDisplay = JSON.stringify({
        allHeaders: [
            {
                headerText: 'string',
                id: 'number | string',
                dataForTemplate: 'any',
                editHeaderText: 'boolean',
            }
        ],
        templateAccordionBody: 'TemplateRef&lt;any&gt;'
    }, null, 4);

    // рыба пользователя
    member: MemberModel = {
        email: 'user_1@asedo.ru',
        firstname: null,
        guid: 'DEV_USER_1',
        has_crypto: null,
        has_pin: true,
        is_active: true,
        is_blocked: false,
        has_avatar: false,
        join_date: '2025-06-22 11:35:52.461443',
        language: 'ru',
        lastname: null,
        middlename: null,
        phone: null,
        project_setting: {
            is_project_admin: true,
            join_date: '2025-06-22 11:35:52.461443',
            key: 'key_here',
            last_request: '2025-07-25 12:48:19.590008',
            observation_type: 'proj_admin',
            position: 'Админ',
            project: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: 'key_here',
                subtype: null,
                type: 'organization'
            }
        },
        projects_list: []
    };

    // рыба для кастомного пользователя
    customMember: MemberModel = {
        email: 'user_1@asedo.ru',
        firstname: null,
        guid: '',
        has_crypto: null,
        has_pin: true,
        has_avatar: false,
        is_active: true,
        is_blocked: false,
        join_date: '2025-06-22 11:35:52.461443',
        language: 'ru',
        lastname: null,
        middlename: null,
        phone: null,
        project_setting: {
            is_project_admin: true,
            join_date: '2025-06-22 11:35:52.461443',
            key: 'key_here',
            last_request: '2025-07-25 12:48:19.590008',
            observation_type: 'proj_admin',
            position: 'Админ',
            project: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: 'key_here',
                subtype: null,
                type: 'organization'
            }
        },
        projects_list: []
    };

    //Рыба кошелька
    wallet: FinanceWalletModel = {
        active: true,
        contract_guid: null,
        created_at: null,
        currency: {
            currency_code: 'RUB',
            exchange_rate_to_base_currency: 1,
            full_name: 'Ruble of Russia',
            id: 1,
            is_active: true,
            is_base_currency: true,
            short_name: 'Ruble'
        },
        guid: 'DEV_USER_1_WALLET',
        is_master: false,
        last_operation_at: null,
        project_guid: '',
        title: 'Рыба кошелька',
        total: 100,
        owner_type: 'PROJECT'
    };

    //Рыба платежей
    payments: PaymentTransactionModel[] = [
        {
            contract: {
                guid: 'a0bbffd0-cf1f-4ba8-ba28-05219502dbf7'
            },
            created_at: '2025-07-29 15:25:22.945141',
            execution_date: null,
            guid: '0e8320be-6a8b-473d-9c75-a5c2a67d5cb8',
            payer: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: '==',
                subtype: null,
                type: 'organization'
            },
            payer_account_guid: '98b0d6c3-3d4d-4c17-9ec4-44b895be7d9c',
            payer_guid: 'SERVER_GG_2_DEV_2',
            payer_type: 'PROJECT',
            payment_hash: null,
            payment_status: 'PROMISED',
            recipient: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: '==2',
                subtype: null,
                type: 'organization'
            },
            recipient_account_guid: '294f0d98-375d-405f-8cd7-c5fa3853c148',
            recipient_guid: 'SERVER_GG_2_DEV_2',
            recipient_type: 'PROJECT',
            total: '8.0',
            updated_at: '2025-07-29 15:25:22.949623'
        },
        {
            contract: {
                guid: 'a0bbffd0-cf1f-4ba8-ba28-05219502dbf7'
            },
            created_at: '2025-07-29 15:25:19.299500',
            execution_date: null,
            guid: '0e26c041-c524-4e57-9e2f-ed7195956819',
            payer: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: '==3',
                subtype: null,
                type: 'organization'
            },
            payer_account_guid: '98b0d6c3-3d4d-4c17-9ec4-44b895be7d9c',
            payer_guid: 'SERVER_GG_2_DEV_2',
            payer_type: 'PROJECT',
            payment_hash: null,
            payment_status: 'PROMISED',
            recipient: {
                created_at: '2025-06-22 11:35:52.362845',
                disk_space: null,
                domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                guid: 'SERVER_GG_2_DEV_2',
                name: 'COMPANY GG-2 DEV-2',
                public_rsa_key: '2==',
                subtype: null,
                type: 'organization'
            },
            recipient_account_guid: '294f0d98-375d-405f-8cd7-c5fa3853c148',
            recipient_guid: 'SERVER_GG_2_DEV_2',
            recipient_type: 'PROJECT',
            total: '8.0',
            updated_at: '2025-07-29 15:25:19.307524'
        },
    ];

    //Рыба проперти
    customProperties: ValuePropertyModel[] = [
        {
            created_at: '2025-07-31 14:46:34.813039',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:42:47.000350',
                id: 1,
                is_multiform: true,
                property_type: 'property_file',
                property_type_target: null,
                title: '\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u044b \u043c\u043d\u043e\u0436\u0435\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u0435',
                updated_at: '2025-07-31 14:42:47.000354',
            },
            property_values: [
                {
                    can_be_deleted: true,
                    chain_hash: null,
                    collection_id: '1',
                    collection_name: 'new test1',
                    contract_guid: null,
                    created_at: '2025-07-31 14:49:23.486813',
                    custom_properties: [],
                    description: '',
                    global_registry_id: null,
                    is_approved: false,
                    is_approved_at: null,
                    is_crypto: false,
                    is_signature_file: false,
                    key: '487141bc-0228-4baf-8ace-42d5d82edf4617539625634868045',
                    latest_version: {
                        created_at: '2025-07-31 14:49:23.503500',
                        description: '',
                        guid_owner: 'DEV_USER_1',
                        id: 1,
                        key: '92c07d87-d1ce-41a1-bf8a-fdcc0d418eed17539625635034847',
                        key_original: '3353c31d-e50c-4cd3-94be-7b649da6778417539625635034943',
                        name: 'new test1.docx',
                        status: 'ok',
                        status_original: 'ok',
                        type_str: 'version'
                    },
                    master: true,
                    name: 'new test1.docx',
                    owner_guid: 'DEV_USER_1',
                    pdf_version: null,
                    signed: false,
                    signed_at: null,
                    signers_guids: [
                        {
                            member_guid: 'DEV_USER_1',
                            sign: false,
                            sign_at: null
                        }
                    ],
                    type_approve: null,
                    type_str: 'file',
                    updated_at: '2025-07-31 14:49:23.486826',
                    versions: [
                        {
                            created_at: '2025-07-31 14:49:23.503500',
                            description: '',
                            guid_owner: 'DEV_USER_1',
                            id: 1,
                            key: '92c07d87-d1ce-41a1-bf8a-fdcc0d418eed17539625635034847',
                            key_original: '3353c31d-e50c-4cd3-94be-7b649da6778417539625635034943',
                            name: 'new test1.docx',
                            status: 'ok',
                            status_original: 'ok',
                            type_str: 'version'
                        }
                    ]
                },
                {
                    can_be_deleted: true,
                    chain_hash: null,
                    collection_id: '1',
                    collection_name: 'new test1',
                    contract_guid: null,
                    created_at: '2025-07-31 14:49:41.824917',
                    custom_properties: [],
                    description: '',
                    global_registry_id: null,
                    is_approved: false,
                    is_approved_at: null,
                    is_crypto: false,
                    is_signature_file: false,
                    key: 'c80ab6bb-6395-41d2-811d-c587c7099081175396258182491',
                    latest_version: {
                        created_at: '2025-07-31 14:49:41.841211',
                        description: '',
                        guid_owner: 'DEV_USER_1',
                        id: 2,
                        key: 'aac82ecc-c7f9-4990-9ae0-5ca99553b27e1753962581841195',
                        key_original: 'dbb84e07-c6bc-488b-b351-f49578b41e8f17539625818412037',
                        name: 'SanDisk Software.pdf',
                        status: 'ok',
                        status_original: 'ok',
                        type_str: 'version',
                    },
                    master: false,
                    name: 'SanDisk Software.pdf',
                    owner_guid: 'DEV_USER_1',
                    pdf_version: null,
                    signed: false,
                    signed_at: null,
                    signers_guids: [
                        {
                            member_guid: 'DEV_USER_1',
                            sign: false,
                            sign_at: null
                        }
                    ],
                    type_approve: null,
                    type_str: 'file',
                    updated_at: '2025-07-31 14:49:41.824930',
                    versions: [
                        {
                            created_at: '2025-07-31 14:49:41.841211',
                            description: '',
                            guid_owner: 'DEV_USER_1',
                            id: 2,
                            key: 'aac82ecc-c7f9-4990-9ae0-5ca99553b27e1753962581841195',
                            key_original: 'dbb84e07-c6bc-488b-b351-f49578b41e8f17539625818412037',
                            name: 'SanDisk Software.pdf',
                            status: 'ok',
                            status_original: 'ok',
                            type_str: 'version',
                        }
                    ]
                }
            ],
            updated_at: '2025-07-31 14:46:34.813043'
        },
        {
            created_at: '2025-07-31 14:46:36.396757',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:43:10.632878',
                id: 2,
                is_multiform: false,
                property_type: 'property_file',
                property_type_target: null,
                title: '\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u044b \u0435\u0434\u0438\u043d\u0438\u0447\u043d\u044b\u0435',
                updated_at: '2025-07-31 14:43:10.632894',
            },
            property_values: {
                can_be_deleted: true,
                chain_hash: null,
                collection_id: '1',
                collection_name: 'new test1',
                contract_guid: null,
                created_at: '2025-07-31 14:49:41.824917',
                custom_properties: [],
                description: '',
                global_registry_id: null,
                is_approved: false,
                is_approved_at: null,
                is_crypto: false,
                is_signature_file: false,
                key: 'c80ab6bb-6395-41d2-811d-c587c7099081175396258182491',
                latest_version: {
                    created_at: '2025-07-31 14:49:41.841211',
                    description: '',
                    guid_owner: 'DEV_USER_1',
                    id: 2,
                    key: 'aac82ecc-c7f9-4990-9ae0-5ca99553b27e1753962581841195',
                    key_original: 'dbb84e07-c6bc-488b-b351-f49578b41e8f17539625818412037',
                    name: 'SanDisk Software.pdf',
                    status: 'ok',
                    status_original: 'ok',
                    type_str: 'version',
                },
                master: false,
                name: 'SanDisk Software.pdf',
                owner_guid: 'DEV_USER_1',
                pdf_version: null,
                signed: false,
                signed_at: null,
                signers_guids: [
                    {
                        member_guid: 'DEV_USER_1',
                        sign: false,
                        sign_at: null
                    }
                ],
                type_approve: null,
                type_str: 'file',
                updated_at: '2025-07-31 14:49:41.824930',
                versions: [
                    {
                        created_at: '2025-07-31 14:49:41.841211',
                        description: '',
                        guid_owner: 'DEV_USER_1',
                        id: 2,
                        key: 'aac82ecc-c7f9-4990-9ae0-5ca99553b27e1753962581841195',
                        key_original: 'dbb84e07-c6bc-488b-b351-f49578b41e8f17539625818412037',
                        name: 'SanDisk Software.pdf',
                        status: 'ok',
                        status_original: 'ok',
                        type_str: 'version',
                    }
                ]
            },
            updated_at: '2025-07-31 14:46:36.396761'
        },
        {
            created_at: '2025-07-31 14:46:39.564344',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:43:29.662643',
                id: 3,
                is_multiform: true,
                property_type: 'property_member',
                property_type_target: 'all',
                title: '\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043c\u043d\u043e\u0436\u0435\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u0439',
                updated_at: '2025-07-31 14:43:29.662648',
            },
            property_values: [
                {
                    email: 'aimee.bins@example.com',
                    firstname: 'Fredy',
                    guid: 'f29d21bb-f658-4654-aea3-6d629be04c55',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-06-23 08:07:59.258168',
                    language: 'ru',
                    lastname: 'Corkery',
                    middlename: 'orchid',
                    phone: null,
                    project_setting: {
                        is_project_admin: false,
                        join_date: '2025-06-23 08:07:59.258168',
                        key: '',
                        last_request: '2025-06-23 08:08:06.259632',
                        observation_type: 'outer',
                        position: 'Strategist',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: '==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                },
                {
                    email: 'admin@asedo.ru',
                    firstname: null,
                    guid: 'DEV_ADMIN_1',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-06-22 11:35:52.438636',
                    language: 'ru',
                    lastname: null,
                    middlename: null,
                    phone: null,
                    project_setting: {
                        is_project_admin: true,
                        join_date: '2025-06-22 11:35:52.438636',
                        key: 'z/DbLOus9KL+ok8sm2dWCvXuE8toz+SYgXjMj4MwLwXLY016L5zeeWZpBpwGTQ0OGY6Hw8SOxAYuk2AdKpsqxCf8POkpl2bx4ri6QH4Qp/PFN/KbQijDXHKPvXHLAw+EcVEt6STIjzqwjJxpyDSpH9f+Z0R5cHmyToz3496g6o4=',
                        last_request: '2025-07-16 12:14:18.010399',
                        observation_type: 'proj_admin',
                        position: 'Universal Admin',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                },
                {
                    email: 'aimee.bins@example.com',
                    firstname: 'Fredy',
                    guid: 'f29d21bb-f658-4654-aea3-6d629be04c55',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-06-23 08:07:59.258168',
                    language: 'ru',
                    lastname: 'Corkery',
                    middlename: 'orchid',
                    phone: null,
                    project_setting: {
                        is_project_admin: false,
                        join_date: '2025-06-23 08:07:59.258168',
                        key: 'gyRzkaaN7cRN1AWSy17PtCVJIP7/9/nbjLwfFIQAHD0R2zZhal4x5hnuAjMr+/lWc/DDxATIELu/vvQbYsdXgEwqLdhDH1Hwoj72Y16qA/9yDnLSc/fkH357HENTj2otyNSOnLS2C7VOtItEaISr8FIGH4FmJBN3GOJnpDB3lrA=',
                        last_request: '2025-06-23 08:08:06.259632',
                        observation_type: 'outer',
                        position: 'Strategist',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                },
                {
                    email: 'admin@asedo.ru',
                    firstname: null,
                    guid: 'DEV_ADMIN_1',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-06-22 11:35:52.438636',
                    language: 'ru',
                    lastname: null,
                    middlename: null,
                    phone: null,
                    project_setting: {
                        is_project_admin: true,
                        join_date: '2025-06-22 11:35:52.438636',
                        key: 'z/DbLOus9KL+ok8sm2dWCvXuE8toz+SYgXjMj4MwLwXLY016L5zeeWZpBpwGTQ0OGY6Hw8SOxAYuk2AdKpsqxCf8POkpl2bx4ri6QH4Qp/PFN/KbQijDXHKPvXHLAw+EcVEt6STIjzqwjJxpyDSpH9f+Z0R5cHmyToz3496g6o4=',
                        last_request: '2025-07-16 12:14:18.010399',
                        observation_type: 'proj_admin',
                        position: 'Universal Admin',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                },
                {
                    email: 'aimee.bins@example.com',
                    firstname: 'Fredy',
                    guid: 'f29d21bb-f658-4654-aea3-6d629be04c55',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-06-23 08:07:59.258168',
                    language: 'ru',
                    lastname: 'Corkery',
                    middlename: 'orchid',
                    phone: null,
                    project_setting: {
                        is_project_admin: false,
                        join_date: '2025-06-23 08:07:59.258168',
                        key: 'gyRzkaaN7cRN1AWSy17PtCVJIP7/9/nbjLwfFIQAHD0R2zZhal4x5hnuAjMr+/lWc/DDxATIELu/vvQbYsdXgEwqLdhDH1Hwoj72Y16qA/9yDnLSc/fkH357HENTj2otyNSOnLS2C7VOtItEaISr8FIGH4FmJBN3GOJnpDB3lrA=',
                        last_request: '2025-06-23 08:08:06.259632',
                        observation_type: 'outer',
                        position: 'Strategist',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                },
                {
                    email: 'dustin_kuvalis81@example.com',
                    firstname: null,
                    guid: '49b826e8-d447-49ab-87a3-994b6ce3f383',
                    has_crypto: null,
                    has_pin: true,
                    is_active: true,
                    is_blocked: false,
                    join_date: '2025-07-31 14:19:28.382834',
                    language: 'ru',
                    lastname: null,
                    middlename: null,
                    phone: '10000000477497482',
                    project_setting: {
                        is_project_admin: true,
                        join_date: '2025-07-31 14:19:28.382834',
                        key: 'eGT/cr7OnyF9SXvclsahyRnvn1VJvmOvYgQ+lLrtqHqT3tST6f/824cH6bu9Rf+rNQt4gFcv/9QDPSfE9cBTUTqJ7g2EfKWIza2LddR8kdFE4zoZwLMRXvR+w/QlfdUJ8yXwV+dLkQkIkSsAcbeoyWjc3nbb7Pz13qD4E8IMBv0=',
                        last_request: null,
                        observation_type: 'proj_admin',
                        position: 'odmen',
                        project: {
                            created_at: '2025-06-22 11:35:52.362845',
                            disk_space: null,
                            domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                            guid: 'SERVER_GG_2_DEV_2',
                            name: 'COMPANY GG-2 DEV-2',
                            public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                            subtype: null,
                            type: 'organization',
                        }
                    },
                    projects_list: []
                }
            ],
            updated_at: '2025-07-31 14:46:39.564349',
        },
        {
            created_at: '2025-07-31 14:46:41.722729',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:43:58.772116',
                id: 4,
                is_multiform: false,
                property_type: 'property_member',
                property_type_target: 'inner',
                title: '\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0435\u0434\u0438\u043d\u0438\u0447\u043d\u044b\u0439 (\u0442\u043e\u043b\u044c\u043a\u043e \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0438)',
                updated_at: '2025-07-31 14:43:58.772130',
            },
            property_values: null,
            updated_at: '2025-07-31 14:46:41.722733',
        },
        {
            created_at: '2025-07-31 14:46:43.349764',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:44:25.449756',
                id: 5,
                is_multiform: false,
                property_type: 'property_member',
                property_type_target: 'outer',
                title: '\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0435\u0434\u0438\u043d\u0438\u0447\u043d\u044b\u0439 (\u0432\u043d\u0435\u0448\u043d\u0438\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0438)',
                updated_at: '2025-07-31 14:44:25.449760',
            },
            property_values: {
                email: 'horace7@example.com',
                firstname: 'Carlie',
                guid: '64f73fff-7fb5-4afa-bb72-d1d9a35e55ed',
                has_crypto: null,
                has_pin: true,
                is_active: true,
                is_blocked: false,
                join_date: '2025-06-23 08:08:07.519142',
                language: 'en',
                lastname: 'Bauch',
                middlename: 'ivory',
                phone: null,
                project_setting: {
                    is_project_admin: false,
                    join_date: '2025-06-23 08:08:07.519142',
                    key: '5SPffgWe8z/fBqm2jyMz8dKEj0WW/savGww7SuIPbcvqfbKAVAa3cI6+U6VgIc41lzd1Bzp2u+3VBgA/UQm9E+R+X3O9cE2nZ5nvVY7MZFV5cGmywgwyujZM7IBbxz5CskaRjCucc+FViU/EFo7APcNWqQ4NC3m4N89Wug4uaZU=',
                    last_request: '2025-06-23 08:08:13.804585',
                    observation_type: 'outer',
                    position: 'Assistant',
                    project: {
                        created_at: '2025-06-22 11:35:52.362845',
                        disk_space: null,
                        domain: 'dev-g1-t2.dev-t.tech-asedo.ru',
                        guid: 'SERVER_GG_2_DEV_2',
                        name: 'COMPANY GG-2 DEV-2',
                        public_rsa_key: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4UmlUTVBURG43YkVNdWNwVTAvbwpsbFNjeWZVd05YUHU2cEdyVTcwSVdWbzNzdUlBYXJjbWtEWVBaRWtRRTY2OGhJdzlkNjdIL251VjJLSlo0V0lhCjg2UlJOejh5bHdRd1dGUG9rdkxNRkVqZHhPTzZDSjg4UzFMS0o1a1JySG5LQzRXVjl4d2oreWs1V092M0dSRk4KVC9uSDNIM3VlQnoxalFWUFVBbXJVeE9rTXhjOVlUR2xaQ21iUFB1d0w2ZmxBZWM0ZFYwVWYxdHk0c1NrSGt0OAo4bURsWUtISGJYRWs0eFFKWE5FRFhLb1pkM29zbEJZdS9LOFc4RUpMejkzZkJCR0FNaVBmUUNYcDRxOEhUamtkCkVrNXJBNi91V1Nnb254MGEvRDBsWmpMcW9lUXI4eXhHUEJWYW5TaFN2ZUFTWXZNVnNTM0NjbzNlN3lwY3JheUgKWXdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
                        subtype: null,
                        type: 'organization',
                    }
                },
                projects_list: []
            },
            updated_at: '2025-07-31 14:46:43.349770',
        },
        {
            created_at: '2025-07-31 14:46:46.083879',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:44:37.562115',
                id: 6,
                is_multiform: false,
                property_type: 'property_text',
                property_type_target: null,
                title: '\u0422\u0435\u043a\u0441\u0442\u043e\u0432\u043e\u0435 \u043f\u043e\u043b\u0435',
                updated_at: '2025-07-31 14:44:37.562118',
            },
            property_values: '\u0422\u0443\u0442 \u0442\u0435\u043a\u0441\u0442',
            updated_at: '2025-07-31 14:46:46.083882',
        },
        {
            created_at: '2025-07-31 14:46:49.725508',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:44:50.727935',
                id: 7,
                is_multiform: false,
                property_type: 'property_boolean',
                property_type_target: null,
                title: '\u041f\u0440\u0438\u0437\u043d\u0430\u043a (\u0434\u0430/\u043d\u0435\u0442)',
                updated_at: '2025-07-31 14:44:50.727944',
            },
            property_values: false,
            updated_at: '2025-07-31 14:46:49.725512',
        },
        {
            created_at: '2025-07-31 14:46:54.784146',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:45:51.005550',
                id: 8,
                is_multiform: true,
                property_type: 'property_catalog',
                property_type_target: '1',
                title: '\u0421\u043f\u0440\u0430\u0432\u043e\u0447\u043d\u0438\u043a (\u043c\u043d\u043e\u0436\u0435\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u0439)',
                updated_at: '2025-07-31 14:45:51.005554',
            },
            property_values: [
                {
                    catalog_id: '1',
                    created_at: '2025-07-31 14:45:18.526552',
                    id: 1,
                    items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 1',
                    sort_index: '1',
                    updated_at: '2025-07-31 14:45:18.526562',
                },
                {
                    catalog_id: '1',
                    created_at: '2025-07-31 14:45:23.162540',
                    id: 2,
                    items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 2',
                    sort_index: '2',
                    updated_at: '2025-07-31 14:45:23.162547',
                }
            ],
            updated_at: '2025-07-31 14:46:54.784151',
        },
        {
            created_at: '2025-07-31 14:46:57.251612',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:46:07.290519',
                id: 9,
                is_multiform: false,
                property_type: 'property_catalog',
                property_type_target: '1',
                title: '\u0421\u043f\u0440\u0430\u0432\u043e\u0447\u043d\u0438\u043a (\u0435\u0434\u0438\u043d\u0438\u0447\u043d\u044b\u0439)',
                updated_at: '2025-07-31 14:46:07.290524',
            },
            property_values: {
                catalog_id: '1',
                created_at: '2025-07-31 14:45:18.526552',
                id: 1,
                items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 1',
                sort_index: '1',
                updated_at: '2025-07-31 14:45:18.526562',
            },
            updated_at: '2025-07-31 14:46:57.251616',
        },
        {
            catalog: {
                created_at: '2025-07-31 14:45:07.008375',
                description: null,
                id: 1,
                is_open: true,
                items: [
                    {
                        catalog_id: 1,
                        created_at: '2025-07-31 14:45:18.526552',
                        id: 1,
                        items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 1',
                        sort_index: 1,
                        updated_at: '2025-07-31 14:45:18.526562',
                    },
                    {
                        catalog_id: 1,
                        created_at: '2025-07-31 14:45:23.162540',
                        id: 2,
                        items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 2',
                        sort_index: 2,
                        updated_at: '2025-07-31 14:45:23.162547',
                    }
                ],
                items_count: 2,
                title: '\u0421\u043f\u0440\u0430\u0432\u043e\u0447\u043d\u0438\u043a',
                updated_at: '2025-07-31 14:45:07.008380',
            },
            created_at: '2025-07-31 14:47:00.226811',
            default_view: true,
            property: {
                created_at: '2025-07-31 14:46:20.849227',
                id: 10,
                is_multiform: true,
                property_type: 'property_todo',
                property_type_target: '1',
                title: '\u0421\u043f\u0440\u0430\u0432\u043e\u0447\u043d\u0438\u043a \u043f\u0440\u0438\u0437\u043d\u0430\u043a\u043e\u0432',
                updated_at: '2025-07-31 14:46:20.849232',
            },
            property_values: [
                {
                    catalog_id: '1',
                    created_at: '2025-07-31 14:45:18.526552',
                    id: 1,
                    items_text: '\u042d\u043b\u0435\u043c\u0435\u043d\u0442 1',
                    sort_index: '1',
                    updated_at: '2025-07-31 14:45:18.526562',
                }
            ],
            updated_at: '2025-07-31 14:47:00.226814',
        }
    ];

    constructor(
        public alert: AlertService,
        public controller: DocumentsServiceService,
        public taskService: TaskServiceService,
        public crmService: CrmService,
    ) {
        controller.loadNav();

        this.taskService.getAllBoards(false).then(res => {
            this.boards = res.boards;
            this.boardGroups = res.groups;
        });
    }

    changeSizeFileTable(): void {
        if (this.isMini === 'default') {
            this.isMini = 'mini';
        } else {
            this.isMini = 'default';
        }
    }

    getTask(taskAlias: string): void {
        this.crmService.getTask(taskAlias).subscribe(task => {
            this.taskData = task.task;
        });
    }
}
